import axiosInstance from "../instance";

// Get All Categories
const fetchDeliveryTypes = async () => {
    const response = await axiosInstance.get('/deliveryTypes');
    return response.data;
}

const addDeliveryType = async (newDeliveryType) => {
    console.log('Add Delivery');
    console.log(newDeliveryType);
    const response = await axiosInstance.post('/deliveryType', newDeliveryType);
    return response.data;
}

const updateDeliveryType = async (newDeliveryType) => {
    console.log('Updating Delivery');
    console.log(newDeliveryType);
    const response = await axiosInstance.put('/deliveryType', newDeliveryType);
    return response.data;
}

const deleteDeliveryType = async (deliveryTypeId) => {
    console.log('Deleting Delivery');
    console.log(deliveryTypeId);

    const response = await axiosInstance.delete('/deliveryType', { params: { deliveryTypeId } });
}

export { fetchDeliveryTypes, addDeliveryType, updateDeliveryType, deleteDeliveryType };